module.exports = __webpack_public_path__ + "static/img/report_back.6da8caa4.png";